// Copyright (c) 2023 Deere & Company

import Dealer, { getDefaultState as getDealerDefaultState } from '../../../sharedmodules/state/dealer';
import File from '../../../sharedmodules/state/file';
import t from 'tcomb';

const DuplicatePINPlate = t.struct({
    approvedRemark: t.String,
    createdBy: t.String,
    dateSubmmited: t.maybe(t.Number),
    dealer: Dealer,
    factory: t.String,
    factoryName: t.String,
    file: t.list(File),
    id: t.String,
    instruction: t.String,
    machineModel: t.String,
    mailingRecipient: t.String,
    missingPlateReason: t.String,
    pin: t.String,
    requesterTCSM: t.String,
    status: t.String,
    updatedBy: t.String,
    updatedTs: t.maybe(t.Number),

}, 'DuplicatePINPlate');

export const getDefaultState = () => new DuplicatePINPlate({
    approvedRemark: '',
    createdBy: '',
    dateSubmmited: null,
    dealer: getDealerDefaultState(),
    factory: '',
    factoryName: '',
    file: [],
    id: '',
    instruction: '',
    machineModel: '',
    mailingRecipient: '',
    missingPlateReason: '',
    pin: '',
    requesterTCSM: '',
    status: '',
    updatedBy: '',
    updatedTs: null,

});

export default DuplicatePINPlate;
